export enum EAccountEditingType {
  NAME = 'name',
  PASSWORD = 'password',
  EMAIL = 'email',
  PHONE = 'phone',
}
